import { render, staticRenderFns } from "./roomdate_detail.vue?vue&type=template&id=980a6248&scoped=true&"
import script from "./roomdate_detail.vue?vue&type=script&lang=js&"
export * from "./roomdate_detail.vue?vue&type=script&lang=js&"
import style0 from "./roomdate_detail.vue?vue&type=style&index=0&id=980a6248&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "980a6248",
  null
  
)

export default component.exports